import { useCallback, useEffect, useState } from 'react';
import api from '../api';

// Every device of the given facilities, straight from the facility device list.
// Unlike the customer device list, this one includes Connect devices that are not
// set up in BTM yet -- the placeholder a held gateway onboarding parks is one.
const useFacilityDevices = facilities => {
    const [data, setData] = useState([]);
    const key = JSON.stringify((facilities || []).map(f => f.facility_id));

    const load = useCallback(async () => {
        const ids = JSON.parse(key);
        if (!ids.length) {
            setData([]);
            return;
        }
        const results = await Promise.allSettled(ids.map(id => api.devices(id)));
        setData(results.flatMap(r => (r.status === 'fulfilled' ? r.value?.data || [] : [])));
    }, [key]);

    useEffect(() => {
        load();
    }, [load]);

    return { data, reload: load };
};

export default useFacilityDevices;
